import { Link } from "react-router-dom";
import { Printer, Download } from "lucide-react";
import { ShareCard } from "@/components/ShareCard";
import { getCards } from "@/lib/cards";

export const PrintableCards = ({ names, title = "Post them, print them, keep them on the fridge", sharePage }) => {
  const cards = getCards(names);
  const printAll = `/print/cards?cards=${names.join(",")}`;
  return (
    <section className="pp-card mt-8" data-testid="printable-cards">
      <p className="pp-label">Printable cards · BurrHaus Counseling</p>
      <h2 className="pp-h2">{title}</h2>
      <div className="pp-cards-grid">
        {cards.map((c) => (
          <figure key={c.name} className="pp-print-card" data-testid={`card-${c.name}`}>
            <img src={c.src} alt={c.alt} loading="lazy" />
            <div className="flex flex-wrap gap-2">
              <ShareCard card={c} page={sharePage} />
              <Link to={`/print/cards?cards=${c.name}`} target="_blank" className="pp-ghost" data-testid={`print-card-${c.name}`}>
                <Printer className="h-4 w-4" /> Print
              </Link>
              <a href={c.src} download={`BurrHaus-${c.name}.png`} className="pp-ghost" data-testid={`download-card-${c.name}`}>
                <Download className="h-4 w-4" /> Save
              </a>
            </div>
            {c.guide && (
              <details className="pp-guide" data-testid={`guide-${c.name}`}>
                <summary data-testid={`guide-toggle-${c.name}`}>Parent talking points</summary>
                <ul>{c.guide.map((g) => <li key={g}>{g}</li>)}</ul>
              </details>
            )}
          </figure>
        ))}
      </div>
      {cards.length > 1 && (
        <div className="pp-actions">
          <Link to={printAll} target="_blank" className="pp-primary" data-testid="print-cards-button">
            <Printer className="h-5 w-5" /> Print all {cards.length} cards
          </Link>
        </div>
      )}
    </section>
  );
};
